import { TeamMember } from './types'

export const useTeam = (): TeamMember[] => {
  return [
    {
      photoSrc: null, //'/Images/Team/Jakub.jpg',
      name: 'Jakub Roztocil',
      title: 'Founder & CEO',
      socialLinks: [
        {
          icon: 'twitter',
          link: 'https://twitter.com/jkbrzt',
        },
        {
          icon: 'github',
          link: 'https://github.com/jkbrzt',
        },
        {
          icon: 'linkedin',
          link: 'https://www.linkedin.com/in/jakubroztocil/',
        },
      ],
    },/*
    {
      photoSrc: '/Images/Team/Claudia.jpg',
      name: 'Cláudia Delgado',
      title: 'Product',
      socialLinks: [
        {
          icon: 'twitter',
          link: 'https://twitter.com/claudiatd',
        },
        {
          icon: 'github',
          link: 'https://github.com/claudiatd',
        },
        {
          icon: 'medium',
          link: 'https://claudiatd.medium.com/',
        },
        {
          icon: 'linkedin',
          link: 'https://www.linkedin.com/in/claudiatd/',
        },
      ],
    },*/
  ]
}
